// extracted by mini-css-extract-plugin
export default {"wrapper":"Thumb-module__wrapper___z0BDo","playSymbol":"Thumb-module__playSymbol___iPyBT"};